import React from "react";
import { PRIVACY_ITEMS, USER_DATA_ITEMS } from "../constants/navigationItems";

const Navigation = ({ scrollToSection }) => {
  const renderPrivacyNav = () => (
    <li>
      <h2>Privacy Policy</h2>
      <ol>
        {PRIVACY_ITEMS.map((title, i) => (
          <li key={`privacy-${i + 1}`}>
            <a
              href={`#privacy-${i + 1}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(`privacy-${i + 1}`, title);
              }}
            >
              {title}
            </a>
          </li>
        ))}
      </ol>
    </li>
  );

  const renderUserDataNav = () => (
    <li>
      <h2>User Data Protection</h2>
      <ol>
        {USER_DATA_ITEMS.map((title, i) => (
          <li key={`data-${i + 1}`}>
            <a
              href={`#data-${i + 1}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(`data-${i + 1}`, title);
              }}
            >
              {title}
            </a>
          </li>
        ))}
      </ol>
    </li>
  );

  return (
    <>
      <nav className={`term-condition-v2__navigation`}>
        <ol>
          {renderPrivacyNav()}
          {renderUserDataNav()}
        </ol>
      </nav>
    </>
  );
};

export default Navigation; 